import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AttachFileDialogComponent } from '../../document-in-library/attach-file-dialog/attach-file-dialog.component';
import { ManageEquipmentService } from '../../manage-equipment/manage-equipment.service';
import { OrdinalDateAdapter, OrdinalDateParse, ORD_DATE_FORMATS } from '../adapters/ordinal-date-adapter';
import { AttachmentsVM, GenericIdName, ImplementInspectionAttachmentsVM } from '../setup-implement/setup-implement.model';
import { SetupImplementService } from '../setup-implement/setup-implement.service';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CryptoService } from '../../../services/crypto.service';
import { NotificationsService } from 'angular2-notifications';
import { ConfirmationBoxComponent } from '../../../shared/confirmation-box/confirmation-box.component';

@Component({
  selector: 'app-inspection-attached-docs',
  templateUrl: './inspection-attached-docs.component.html',
  styleUrls: ['./inspection-attached-docs.component.scss'],
  providers: [
    {
        provide: DateAdapter, useClass: OrdinalDateAdapter
    },
    {
        provide: MAT_DATE_FORMATS, useValue: ORD_DATE_FORMATS
    }
]
})
export class InspectionAttachedDocsComponent implements OnInit {

  IsUC:boolean=false;
  InspectionDate: Date;
  SMU: number
  InspectionId: number
  username: string

  DocTypes: GenericIdName[];
  ord: OrdinalDateParse = new OrdinalDateParse();

  minDate: Date = new Date();
  maxDate: Date = new Date();

  slectedDocTypeId: number;
  startDate: Date;
  DocComment: string
  DocAttacheId: number = 0;
  attachmentList: AttachmentsVM[] = []
  DocInfo: ImplementInspectionAttachmentsVM;
  loading: boolean = false;
  includeInReport: boolean = false;
  constructor(public dialogRef: MatDialogRef<InspectionAttachedDocsComponent>, public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any, private _implementService: SetupImplementService,
    private _equipmentService: ManageEquipmentService,
    private _router: Router,
    private _crypto: CryptoService,
    private _notify: NotificationsService) { }

  ngOnInit() {
    this.startDate =  new Date();
    this.SMU = this.data.SMU;
    this.InspectionDate = this.data.InspectionDate;
    this.InspectionId = this.data.InspectionId;
    this.IsUC=this.data.IsUC;
    this.LoadDocTypesForImplementAttachments();
    this.LoadDocumentInfo();
  }

  // Date
  dateChanged(): void {
    this.ord.formatDateOrdinal((this.startDate.toString())
      .split(' ')
      .slice(1)
      .join(' '), false);
  }


  updateInspectionDoc() {
    if(this.attachmentList.length==0){
      this._notify.alert('Please attach at least one document.');
      return;
    }
    if(this.slectedDocTypeId==null || this.slectedDocTypeId==0){
      this._notify.alert('Please select document type.');
      return;
    }
    this.loading = true;
    let parms = new ImplementInspectionAttachmentsVM();
    parms.Id = this.DocAttacheId;
    parms.DocTypeId = this.slectedDocTypeId;
    parms.CreateDate = new Date(this.startDate);
    parms.Attachments = this.attachmentList;
    parms.Comment = this.DocComment;
    parms.InspectionId = this.InspectionId;
    parms.IncludeInReport = this.includeInReport;
    if(this.IsUC==false){
      this._implementService.SaveImplementInspectionDocuments(parms).subscribe((res: any) => {
        if (res == true) {
          this._notify.success('Documents saved successfully.');
          this.loading = false;
          this.dialogRef.close();
        }
        else{
          this._notify.error('Error while saving documents.');
          this.loading = false;
        }
      })
    }else{
      //UC
      this._equipmentService.SaveUCInspectionDocuments(parms).subscribe(res => {
        if (res == true) {
          this._notify.success('Documents saved successfully.');
          this.loading = false;
          this.dialogRef.close();
        }
        else{
          this._notify.error('Error while saving documents.');
          this.loading = false;
        }
      })
    }
   


  }

  openDeleteConfirmationBox(i) {
    const dialogRef = this.dialog.open(ConfirmationBoxComponent, {
      width: '400px',
      data: {
        title: 'Delete',
        message: 'Are you sure you want to delete this document?',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        let array = [];
        array = this.attachmentList;
        array.splice(i, 1)
        this.attachmentList = array
        this._notify.alert('Document is deleted from list. You need to save to apply changes.');
      }
    });
  }

  LoadDocumentInfo() {
    if(this.IsUC==false){
      this._implementService.GetInspectionDocInfo(this.InspectionId).subscribe(res => {
        if (res.Id > 0) {
          this.DocInfo = res;
          this.attachmentList = this.DocInfo.Attachments;
          this.slectedDocTypeId = this.DocInfo.DocTypeId;
          this.startDate = this.DocInfo.CreateDate;
          this.DocAttacheId = this.DocInfo.Id;
          this.DocComment = this.DocInfo.Comment;
          this.username = this._crypto.decrypt(this.DocInfo.username);
          this.includeInReport = this.DocInfo.IncludeInReport;
        }
        else {
          this.username = this._crypto.decrypt(res.username);
        }
      })
    } else{
      this._equipmentService.GetUCInspectionDocInfo(this.InspectionId).subscribe(res => {
        if (res.Id > 0) {
          this.DocInfo = res;
          this.attachmentList = this.DocInfo.Attachments;
          this.slectedDocTypeId = this.DocInfo.DocTypeId;
          this.startDate = this.DocInfo.CreateDate;
          this.DocAttacheId = this.DocInfo.Id;
          this.DocComment = this.DocInfo.Comment;
          this.includeInReport = this.DocInfo.IncludeInReport;
          this.username = this._crypto.decrypt(this.DocInfo.username);
        }
        else {
          this.username = this._crypto.decrypt(res.username);
        }
      })
    }
  }
  LoadDocTypesForImplementAttachments() {
    this._implementService.GetImplementAttchDocTypes().subscribe(res => {
      this.DocTypes = res;
      this.minDate = new Date(this.InspectionDate);
    })
  }

  onCloseClick() {
    this.dialogRef.close();
  }
  Extension: string
  FilePreview: string
  FileName:string=""
  openAttachDoc() {
    const dialogRef = this.dialog.open(AttachFileDialogComponent, {
      data: {

      }
    });
    dialogRef.afterClosed().subscribe(res => {
      console.log("res", res)
      if (res != false) {
        var images_ = (res.FilePreview).split(',');
        this.FilePreview = images_[1];
        this.FileName=res.NewFileName

        this.Extension = res.Extension;

        let params = new AttachmentsVM();
        params.Data = this.FilePreview;
        params.extention = this.Extension;
      params.isNew = true;
      params.docInfo = "";
     params.FileName=this.FileName
      

        let arr_ = [];
        arr_.push(params);

        if (this.attachmentList == null) {
          this.attachmentList = arr_;

        } else {
          this.attachmentList.push(params);
        }
        console.log(" this.attachmentList", this.attachmentList)

      }

    });

  }
  
  onClickDownloadForm(form) {

    // var newstring = form.Data;
     console.log('infooo ', form)

    // let _newstring = newstring.substring(0, newstring);
    // console.log("newstringnewstringnewstring", _newstring)
   
    var arrBuffer = this.base64ToArrayBuffer(form.Data);

    if (form.extention == 'pdf') {
      var blob = new Blob([arrBuffer], { type: 'application/pdf' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName!=null?form.FileName + '.pdf':'Attachment_' + '.pdf';
      link.click();
    }
    else if (form.extention == 'xls') {
      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName + '.xls';
      link.click();
    }
    else if (form.extention == 'docx') {
      var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName + '.docx';
      link.click();
    }
    else if (form.extention == 'png') {
      var blob = new Blob([arrBuffer], { type: 'image/png' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName + '.png';
      link.click();
    }

    else if (form.extention == 'jpg') {
      var blob = new Blob([arrBuffer], { type: 'image/jpg' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName + '.jpg';
      link.click();
    }

    else if (form.extention == 'txt') {
      var blob = new Blob([arrBuffer], { type: 'application/octet-stream' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName + '.txt';
      link.click();
    }
    else if (form.extention == 'doc') {
      var blob = new Blob([arrBuffer], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = form.FileName + '.doc';
      link.click();
    }
  }

  base64ToArrayBuffer(base64) {
    console.log("base64", base64)
    var binaryString = window.atob(base64);
    var binaryLen = binaryString.length;
    var bytes = new Uint8Array(binaryLen);
    for (var i = 0; i < binaryLen; i++) {
      var ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  onIncludeInReportChange(event){
    this.includeInReport = event.checked;
  }
}
